// src/Portfolio.js
import React, { useState, useEffect } from 'react';
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Modal,
  Form,
  Alert,
  ProgressBar
} from 'react-bootstrap';
import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaExternalLinkAlt,
  FaCode,
  FaUsers,
  FaCalendarAlt,
  FaAward,
  FaBookOpen,
  FaLaptopCode,
  FaDatabase,
  FaReact,
  FaPython,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaBootstrap,
  FaGitAlt,
  FaLinux,
  FaPalette,
  FaPhp,
  FaAndroid
} from 'react-icons/fa';

// Import your images
import profileImg from './image/profile.jpeg';
import fynBridalImg from './image/fyn bridal app.png';
import groupWebsiteImg from './image/group project 2.png';
import groupWebsiteDemoImg from './image/group project demo.png';
import groupWebsite1Img from './image/group-project-1.png';
import reactAppImg from './image/react_project demo.png';
import ecommerceApiImg from './image/ecommerce-api-screenshot.png';

function Portfolio() {
  const [activeSection, setActiveSection] = useState('about');
  const [showContactModal, setShowContactModal] = useState(false);
  const [currentTheme, setCurrentTheme] = useState('professional-grey');
  const [showAlert, setShowAlert] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [currentDemo, setCurrentDemo] = useState({ title: '', url: '', description: '' });
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [imageTitle, setImageTitle] = useState('');

  // Theme configurations
  const themes = {
    'professional-grey': {
      name: 'Professional Grey',
      primary: '#2D3748',
      secondary: '#4A5568',
      background: 'linear-gradient(135deg, #2D3748 0%, #4A5568 100%)',
      navbar: 'navbar-dark',
      cardBg: 'bg-light'
    },
    'tech-blue': {
      name: 'Tech Blue',
      primary: '#0d6efd',
      secondary: '#6c757d',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      navbar: 'navbar-dark bg-primary',
      cardBg: 'bg-light'
    },
    'modern-teal': {
      name: 'Modern Teal',
      primary: '#20c997',
      secondary: '#6c757d',
      background: 'linear-gradient(135deg, #20c997 0%, #0dcaf0 100%)',
      navbar: 'navbar-dark',
      cardBg: 'bg-light'
    },
    'professional-purple': {
      name: 'Professional Purple',
      primary: '#6f42c1',
      secondary: '#6c757d',
      background: 'linear-gradient(135deg, #6f42c1 0%, #d63384 100%)',
      navbar: 'navbar-dark',
      cardBg: 'bg-light'
    },
    'elegant-dark': {
      name: 'Elegant Dark',
      primary: '#212529',
      secondary: '#6c757d',
      background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
      navbar: 'navbar-dark bg-dark',
      cardBg: 'bg-dark text-white'
    }
  };

  const currentThemeConfig = themes[currentTheme];

  // Projects data - UPDATED WITH YOUR CORRECT GITHUB LINKS
  const projects = [
    {
      id: 1,
      title: "Fyn Bridal",
      description: "Android mobile application for bridal services management. Currently in development with Flutter and Firebase integration.",
      technologies: ["Flutter", "Dart", "Firebase", "Android Studio", "REST API"],
      type: "Android App (In Progress)",
      year: "2026",
      github: "https://github.com/nawamwenanazifa/fyn_bridals-mobile-app",
      demo: "#",
      image: fynBridalImg,
      highlights: [
        "Cross-platform mobile development with Flutter",
        "Firebase authentication and database",
        "User-friendly interface design",
        "Real-time data synchronization"
      ],
      status: "In Progress"
    },
    {
      id: 2,
      title: "UNIHUB SOLUTIONS",
      description: "Collaborative website built during Year 1 recess with a team of 2 students. Implemented modern web technologies and responsive design principles.",
      technologies: ["HTML5", "CSS3", "JavaScript", "Bootstrap", "Responsive Design"],
      type: "Group Project",
      year: "2024",
      github: "https://github.com/phionaaladina/UNIHUB-SOLUTIONS",
      demo: "#",
      image: groupWebsiteImg,
      highlights: [
        "Collaborated effectively in a team of 2",
        "Implemented responsive design",
        "Applied web development best practices",
        "Used version control with Git"
      ],
      status: "Completed"
    },
    {
      id: 3,
      title: "Personal React Portfolio",
      description: "A React-based portfolio showcasing component-based architecture and modern JavaScript ES6+ features.",
      technologies: ["React", "JavaScript", "Bootstrap", "CSS3", "Git"],
      type: "Individual Project",
      year: "2024",
      github: "https://github.com/nawamwenanazifa/nawamwena-portfolio",
      demo: "#",
      image: reactAppImg,
      highlights: [
        "Component-based architecture",
        "State management with hooks",
        "Modern JavaScript features",
        "Responsive user interface"
      ],
      status: "Completed"
    },
    {
      id: 4,
      title: "E-commerce Backend API",
      description: "Laravel-based REST API for e-commerce application with authentication, product management, and order processing.",
      technologies: ["Laravel", "PHP", "MySQL", "JWT", "REST API"],
      type: "Individual Project",
      year: "2025",
      github: "https://github.com/SummitCoaches/SummitCoachesBackend",
      demo: "#",
      image: ecommerceApiImg,
      highlights: [
        "RESTful API design with Laravel",
        "JWT Authentication",
        "Database design and optimization",
        "API documentation"
      ],
      status: "Completed"
    }
  ];

  // Skills data with icons - UPDATED with Laravel and Flutter
  const skills = [
    {
      category: "Programming Languages",
      items: [
        { name: "JavaScript", icon: <FaJs className="text-warning" />, level: 85 },
        { name: "Python", icon: <FaPython className="text-info" />, level: 80 },
        { name: "PHP", icon: <FaCode className="text-primary" />, level: 75 },
        { name: "Dart", icon: <FaCode className="text-info" />, level: 70 },
        { name: "HTML5", icon: <FaHtml5 className="text-danger" />, level: 90 },
        { name: "CSS3", icon: <FaCss3Alt className="text-primary" />, level: 85 }
      ]
    },
    {
      category: "Frameworks & Libraries",
      items: [
        { name: "React", icon: <FaReact className="text-info" />, level: 80 },
        { name: "Laravel", icon: <FaCode className="text-danger" />, level: 75 },
        { name: "Flutter", icon: <FaCode className="text-primary" />, level: 70 },
        { name: "Bootstrap", icon: <FaBootstrap className="text-primary" />, level: 85 },
        { name: "Flask", icon: <FaCode className="text-success" />, level: 75 }
      ]
    },
    {
      category: "Tools & Technologies",
      items: [
        { name: "Git", icon: <FaGitAlt className="text-danger" />, level: 80 },
        { name: "GitHub", icon: <FaGithub className="text-dark" />, level: 85 },
        { name: "MySQL", icon: <FaDatabase className="text-info" />, level: 75 },
        { name: "Linux", icon: <FaLinux className="text-dark" />, level: 70 }
      ]
    }
  ];

  // Education data - UPDATED (removed GPA, updated graduation)
  const education = {
    institution: "Women Institute of Innovation and Technology",
    program: "Diploma in Computer Science and Information Technology",
    year: "Final Year, Final Semester",
    location: "Uganda",
    joined: "2024",
    expectedGraduation: "August 2026"
  };

  // Handle contact form submission
  const handleContactSubmit = (e) => {
    e.preventDefault();
    setShowContactModal(false);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  // Handle demo viewing
  const handleViewDemo = (project) => {
    setCurrentDemo({
      title: project.title,
      url: project.demo,
      description: project.description
    });
    setShowDemoModal(true);
  };

  // Handle image click to view larger
  const handleImageClick = (image, title) => {
    setSelectedImage(image);
    setImageTitle(title);
    setShowImageModal(true);
  };

  // Handle image loading errors
  const handleImageError = (e) => {
    e.target.src = 'https://via.placeholder.com/400x200/cccccc/ffffff?text=Image+Not+Found';
  };

  // Scroll to section
  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="Portfolio">
      {/* Custom CSS for themes */}
      <style jsx>{`
        .hero-section {
          background: ${currentThemeConfig.background};
          color: white;
          padding: 100px 0;
          position: relative;
        }
        
        .theme-primary {
          color: ${currentThemeConfig.primary} !important;
        }
        
        .btn-theme-primary {
          background-color: ${currentThemeConfig.primary};
          border-color: ${currentThemeConfig.primary};
        }
        
        .btn-theme-primary:hover {
          background-color: ${currentThemeConfig.primary};
          border-color: ${currentThemeConfig.primary};
          opacity: 0.9;
        }

        .navbar-custom {
          background: ${currentThemeConfig.primary} !important;
        }

        .project-card:hover {
          transform: translateY(-5px);
          transition: all 0.3s ease;
        }

        .skill-icon {
          font-size: 2rem;
          margin-bottom: 1rem;
        }
      `}</style>

      {/* Navigation Bar */}
      <Navbar expand="lg" className="navbar-custom fixed-top" variant="dark">
        <Container>
          <Navbar.Brand href="#home" className="fw-bold">
            <FaLaptopCode className="me-2" />
            Portfolio
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {['about', 'projects', 'skills', 'education', 'contact'].map((section) => (
                <Nav.Link
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className={activeSection === section ? 'active fw-bold' : ''}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </Nav.Link>
              ))}
            </Nav>
            
            {/* Theme Switcher */}
            <Nav className="ms-auto">
              <div className="btn-group">
                {Object.entries(themes).map(([key, theme]) => (
                  <Button
                    key={key}
                    variant={currentTheme === key ? "light" : "outline-light"}
                    size="sm"
                    className="me-1"
                    onClick={() => setCurrentTheme(key)}
                    title={theme.name}
                  >
                    <FaPalette className="me-1" />
                    {theme.name.split(' ')[0]}
                  </Button>
                ))}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Alert for form submission */}
      {showAlert && (
        <Alert variant="success" className="position-fixed" style={{ top: '80px', right: '20px', zIndex: 1050 }}>
          Message sent successfully! I'll get back to you soon.
        </Alert>
      )}

      {/* Hero Section */}
      <section id="about" className="hero-section">
        <Container>
          <Row className="align-items-center min-vh-100">
            <Col lg={8} className="mx-auto text-center">
              <div className="mb-4">
                <img 
                  src={profileImg}
                  alt="Profile"
                  className="rounded-circle mx-auto mb-4"
                  style={{ 
                    width: '150px', 
                    height: '150px', 
                    objectFit: 'cover',
                    border: '3px solid white'
                  }}
                  onError={handleImageError}
                />
                <h1 className="display-4 fw-bold mb-4">Computer Science Student</h1>
                <p className="lead mb-4">
                  Passionate about technology, innovation, and building the future through code
                </p>
                
                {/* Quick Info */}
                <Row className="justify-content-center">
                  <Col md={4} className="mb-2">
                    <FaBookOpen className="me-2" />
                    {education.program}
                  </Col>
                  <Col md={3} className="mb-2">
                    <FaCalendarAlt className="me-2" />
                    {education.year}
                  </Col>
                  <Col md={3} className="mb-2">
                    <FaMapMarkerAlt className="me-2" />
                    {education.location}
                  </Col>
                </Row>

                <div className="mt-5">
                  <Button 
                    variant="light" 
                    size="lg" 
                    className="me-3 mb-3"
                    onClick={() => setShowContactModal(true)}
                  >
                    <FaEnvelope className="me-2" />
                    Get In Touch
                  </Button>
                  <Button 
                    variant="outline-light" 
                    size="lg" 
                    className="mb-3"
                    onClick={() => scrollToSection('projects')}
                  >
                    View Projects
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row>
            <Col lg={6} className="mb-4">
              <h2 className="theme-primary fw-bold mb-4">About Me</h2>
              <p className="lead">
                I'm a dedicated Computer Science and Information Technology student at the Women Institute of Innovation and Technology, 
                currently in my final year, final semester. I'm passionate about leveraging technology to create innovative solutions.
              </p>
              <p>
                My journey in tech has been focused on web development, mobile app development (Flutter/Android), and understanding the foundations 
                of computer science. I'm actively involved with Women in Technology Uganda, where I contribute to empowering 
                women in the tech industry.
              </p>
              <p>
                I believe in the power of technology to transform lives and communities, and I'm committed to continuous learning 
                and skill development.
              </p>
            </Col>
            <Col lg={6}>
              <Row>
                <Col md={6} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex align-items-center mb-3">
                        <FaAward className="theme-primary me-3" size={30} />
                        <h5 className="mb-0">Education</h5>
                      </div>
                      <h6>{education.institution}</h6>
                      <p className="theme-primary mb-1">{education.program}</p>
                      <small className="text-muted">{education.year}</small>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex align-items-center mb-3">
                        <FaUsers className="theme-primary me-3" size={30} />
                        <h5 className="mb-0">Organizations</h5>
                      </div>
                      <h6>Women in Technology Uganda</h6>
                      <p className="theme-primary mb-1">Active Member</p>
                      <small className="text-muted">2023 - Present</small>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-5">
        <Container>
          <h2 className="text-center theme-primary fw-bold mb-5">My Projects</h2>
          <Row>
            {projects.map((project) => (
              <Col lg={4} md={6} className="mb-4" key={project.id}>
                <Card className="h-100 shadow project-card">
                  <Card.Img 
                    variant="top" 
                    src={project.image} 
                    height="200" 
                    style={{objectFit: 'cover'}}
                    onError={handleImageError}
                  />
                  <Card.Body className="d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="card-title">{project.title}</h5>
                      <Badge bg={project.status === 'Completed' ? 'success' : 'warning'}>
                        {project.status}
                      </Badge>
                    </div>
                    
                    <div className="d-flex align-items-center mb-3 text-muted">
                      {project.type === 'Group Project' ? <FaUsers className="me-2" /> : project.type.includes('Android') ? <FaAndroid className="me-2" /> : <FaCode className="me-2" />}
                      <small>{project.type} • {project.year}</small>
                    </div>
                    
                    <Card.Text>{project.description}</Card.Text>
                    
                    <div className="mb-3">
                      <h6>Key Highlights:</h6>
                      <ul className="small">
                        {project.highlights.slice(0, 2).map((highlight, index) => (
                          <li key={index}>{highlight}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="mb-3">
                      {project.technologies.slice(0, 3).map((tech, index) => (
                        <Badge key={index} bg="secondary" className="me-1 mb-1">
                          {tech}
                        </Badge>
                      ))}
                      {project.technologies.length > 3 && (
                        <Badge bg="light" text="dark">+{project.technologies.length - 3} more</Badge>
                      )}
                    </div>

                    {/* Additional images for group project */}
                    {project.id === 2 && (
                      <div className="mt-2 mb-3">
                        <small className="text-muted">More screenshots:</small>
                        <div className="d-flex gap-2 mt-1">
                          <img 
                            src={groupWebsiteDemoImg} 
                            alt="Demo view"
                            style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer' }}
                            className="rounded border"
                            onClick={() => handleImageClick(groupWebsiteDemoImg, 'Group Project Demo')}
                            onError={handleImageError}
                          />
                          <img 
                            src={groupWebsite1Img} 
                            alt="Project view 1"
                            style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer' }}
                            className="rounded border"
                            onClick={() => handleImageClick(groupWebsite1Img, 'Group Project Screenshot 1')}
                            onError={handleImageError}
                          />
                        </div>
                      </div>
                    )}
                    
                    <div className="mt-auto">
                      <Button variant="outline-primary" size="sm" className="me-2" href={project.github} target="_blank">
                        <FaGithub className="me-1" />
                        GitHub
                      </Button>
                      {project.demo !== '#' && (
                        <Button 
                          variant="outline-success" 
                          size="sm" 
                          onClick={() => handleViewDemo(project)}
                        >
                          <FaExternalLinkAlt className="me-1" />
                          View Demo
                        </Button>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Skills Section */}
      <section id="skills" className="py-5 bg-light">
        <Container>
          <h2 className="text-center theme-primary fw-bold mb-5">Skills & Technologies</h2>
          {skills.map((skillGroup, index) => (
            <Row key={index} className="mb-5">
              <Col lg={3}>
                <h4 className="theme-primary">{skillGroup.category}</h4>
              </Col>
              <Col lg={9}>
                <Row>
                  {skillGroup.items.map((skill, skillIndex) => (
                    <Col md={6} className="mb-3" key={skillIndex}>
                      <div className="d-flex align-items-center mb-2">
                        <span className="skill-icon me-2">{skill.icon}</span>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="fw-semibold">{skill.name}</span>
                            <span className="text-muted small">{skill.level}%</span>
                          </div>
                          <ProgressBar now={skill.level} variant={skill.level > 80 ? 'success' : skill.level > 60 ? 'info' : 'warning'} />
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          ))}
        </Container>
      </section>

      {/* Education Section */}
      <section id="education" className="py-5">
        <Container>
          <h2 className="text-center theme-primary fw-bold mb-5">Education</h2>
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card className="shadow-lg">
                <Card.Body className="p-5">
                  <Row>
                    <Col md={3} className="text-center mb-4">
                      <FaAward className="theme-primary" size={60} />
                    </Col>
                    <Col md={9}>
                      <h3 className="theme-primary">{education.institution}</h3>
                      <h5 className="mb-3">{education.program}</h5>
                      <Row>
                        <Col sm={6}>
                          <p><strong>Current Status:</strong> {education.year}</p>
                          <p><strong>Joined:</strong> {education.joined}</p>
                        </Col>
                        <Col sm={6}>
                          <p><strong>Expected Graduation:</strong> {education.expectedGraduation}</p>
                          <p><strong>Location:</strong> {education.location}</p>
                        </Col>
                      </Row>
                      <h6 className="mt-3 mb-2">Relevant Coursework:</h6>
                      <Row>
                        <Col md={6}>
                          <ul className="small">
                            <li>Data Structures & Algorithms</li>
                            <li>Web Development</li>
                            <li>Database Systems</li>
                            <li>Mobile App Development (Flutter)</li>
                          </ul>
                        </Col>
                        <Col md={6}>
                          <ul className="small">
                            <li>Software Engineering</li>
                            <li>Computer Networks</li>
                            <li>PHP & Laravel Framework</li>
                            <li>Android Development</li>
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5 bg-light">
        <Container>
          <h2 className="text-center theme-primary fw-bold mb-5">Let's Connect</h2>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <p className="lead mb-5">
                I'm always interested in new opportunities, collaborations, and connecting with fellow tech enthusiasts.
                Feel free to reach out!
              </p>
              <Row>
                <Col md={4} className="mb-4">
                  <Card className="h-100 shadow-sm border-0">
                    <Card.Body className="text-center">
                      <FaEnvelope className="theme-primary mb-3" size={40} />
                      <h5>Email</h5>
                      <p className="text-muted">phiona.aladina@example.com</p>
                      <Button 
                        variant="outline-primary" 
                        onClick={() => setShowContactModal(true)}
                      >
                        Send Message
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4} className="mb-4">
                  <Card className="h-100 shadow-sm border-0">
                    <Card.Body className="text-center">
                      <FaGithub className="theme-primary mb-3" size={40} />
                      <h5>GitHub</h5>
                      <p className="text-muted">@nawamwenanazifa</p>
                      <Button 
                        variant="outline-primary" 
                        href="https://github.com/nawamwenanazifa" 
                        target="_blank"
                      >
                        View Profile
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4} className="mb-4">
                  <Card className="h-100 shadow-sm border-0">
                    <Card.Body className="text-center">
                      <FaLinkedin className="theme-primary mb-3" size={40} />
                      <h5>LinkedIn</h5>
                      <p className="text-muted">Your Profile</p>
                      <Button 
                        variant="outline-primary" 
                        href="https://linkedin.com/in/yourprofile" 
                        target="_blank"
                      >
                        Connect
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <footer className="py-4 bg-dark text-white text-center">
        <Container>
          <p className="mb-2">
            © 2026 Computer Science Student Portfolio. Built with React and Bootstrap.
          </p>
          <p className="small text-muted">
            Current Theme: {currentThemeConfig.name} • Hosted on GitHub Pages
          </p>
        </Container>
      </footer>

      {/* Demo Modal */}
      <Modal 
        show={showDemoModal} 
        onHide={() => setShowDemoModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{currentDemo.title} - Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <p className="text-muted">{currentDemo.description}</p>
            <hr />
            <div className="text-center">
              <p className="mb-3">Click the button below to view the full demo:</p>
              <Button 
                variant="primary" 
                size="lg"
                href={currentDemo.url}
                target="_blank"
                className="mb-3"
              >
                <FaExternalLinkAlt className="me-2" />
                Open Demo in New Tab
              </Button>
              <p className="small text-muted">
                Note: If the demo doesn't open, please check your internet connection or try again later.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDemoModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image Gallery Modal */}
      <Modal 
        show={showImageModal} 
        onHide={() => setShowImageModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{imageTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img 
            src={selectedImage} 
            alt={imageTitle}
            style={{ maxWidth: '100%', maxHeight: '70vh' }}
            onError={handleImageError}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Contact Modal */}
      <Modal show={showContactModal} onHide={() => setShowContactModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Send Message</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleContactSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Your Name</Form.Label>
              <Form.Control type="text" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control type="email" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control type="text" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={4} required />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowContactModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Send Message
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Portfolio;